<template>
  <div class="fit layout-padding">
    <div class="row justify-center">
      <q-list class="col-12 round" :sparse="true" style="padding: 0">
        <q-collapsible group="roles" :separator="true" v-if="$p(['ADMIN','MANAGER','AFFILIATE'],'or')" :class="{'error': validation.instructorForm.$invalid}">
          <template slot="header">
            <q-item-main><h5><q-icon color="primary" name="fa fa-graduation-cap"></q-icon> Instructor</h5></q-item-main>
            <q-item-side right>
              <q-icon v-if="validation.instructorForm.$invalid" name="fa fa-flag" color="red" class="exclamation-circle-icon"/>
              <q-toggle 
                name="Active"
                left-label
                size="24px"
                v-model="instructorForm.ACTIVE_IND" 
                :disable="!canEdit || !$p(['ADMIN','MANAGER','AFFILIATE'],'or')"
                :label="activateLabel(instructorForm.ACTIVE_IND, instructorForm.INSTRUCTOR_ID)"
                :keep-color="activateLabel(instructorForm.ACTIVE_IND, instructorForm.INSTRUCTOR_ID) == 'Inactive' ? true : false"
                :color="activateLabel(instructorForm.ACTIVE_IND, instructorForm.INSTRUCTOR_ID) == 'Inactive' ? 'red' : 'green'"
                @input="updateInstructorForm({field: 'ACTIVE_IND', value: instructorForm.ACTIVE_IND })"/>
            </q-item-side>
          </template>
          <div>
            <user-details-instructor-form :validation="validation" />
          </div>
        </q-collapsible>
        <q-collapsible group="roles" :separator="true" v-if="$p(['ADMIN','MANAGER','RECRUITER'],'or') && (module !=='instructorApprovals')" :class="{'error': validation.affiliateForm.$invalid}">
          <template slot="header">
            <q-item-main><h5><q-icon color="primary" name="fa fa-building"></q-icon> Affiliate</h5></q-item-main>
            <q-item-side right>
              <q-icon v-if="validation.affiliateForm.$invalid || validation.affiliateForm.$invalid" name="fa fa-flag" color="red" class="exclamation-circle-icon"/>
              <q-toggle 
              name="Active"
              :label="activateLabel(affiliateForm.ACTIVE_IND, affiliateForm.AFFILIATE_ID)"
              :keep-color="activateLabel(affiliateForm.ACTIVE_IND, affiliateForm.AFFILIATE_ID) == 'Inactive' ? true : false"
              :color="activateLabel(affiliateForm.ACTIVE_IND, affiliateForm.AFFILIATE_ID) == 'Inactive' ? 'red' : 'green'"
              left-label
               size="24px" 
              v-model="affiliateForm.ACTIVE_IND"  
              :disable="!canEdit || !$p(['ADMIN','MANAGER'],'or')"
              @change="updateAffiliateForm({field: 'ACTIVE_IND', value: affiliateForm.ACTIVE_IND })"/>
            </q-item-side>
          </template>
          <div >
            <user-details-affiliate-form :validation="validation"/>
            <!-- <user-grid-affiliate /> -->
          </div>
        </q-collapsible>
        <q-collapsible group="roles" :separator="true" v-if="$p(['ADMIN','MANAGER'],'or') && (module !=='instructorApprovals')" :class="{'error': validation.recruiterForm.$invalid}">
          <template slot="header">
            <q-item-main><h5><q-icon color="primary" name="fa fa-user-plus"></q-icon> Recruiter</h5></q-item-main>
            <q-item-side right>
              <q-icon v-if="validation.recruiterForm.$invalid" name="fa fa-flag" color="red" class="exclamation-circle-icon"/>
              <q-toggle 
              name="Active"
              :label="activateLabel(recruiterForm.ACTIVE_IND, recruiterForm.RECRUITER_ID)"
              :keep-color="activateLabel(recruiterForm.ACTIVE_IND, recruiterForm.RECRUITER_ID) == 'Inactive' ? true : false"
              :color="activateLabel(recruiterForm.ACTIVE_IND, recruiterForm.RECRUITER_ID) == 'Inactive' ? 'red' : 'green'"
              left-label
              size="24px"
              v-model="recruiterForm.ACTIVE_IND"
              :disable="!canEdit || !$p(['ADMIN','MANAGER'],'or')"
              @change="updateRecruiterForm({field: 'ACTIVE_IND', value: recruiterForm.ACTIVE_IND })"/>
            </q-item-side>
          </template>
          <div>
            <user-details-recruiter-form :validation="validation"/>
            <!-- <user-grid-instructor /> -->
          </div>
        </q-collapsible>
        <q-collapsible group="roles" :separator="true" v-if="$p(['ADMIN']) && (module !=='instructorApprovals')" :class="{'error': validation.managerForm.$invalid}">
          <template slot="header">
            <q-item-main><h5><q-icon color="primary" name="fa fa-users"></q-icon> Manager</h5></q-item-main>
            <q-item-side right>
              <q-icon v-if="validation.managerForm.$invalid" name="fa fa-flag" color="red" class="exclamation-circle-icon"/>
              <q-toggle 
              name="Active"
              left-label
              :label="activateLabel(managerForm.ACTIVE_IND, managerForm.MANAGER_ID)"
              :keep-color="activateLabel(managerForm.ACTIVE_IND, managerForm.MANAGER_ID) == 'Inactive' ? true : false"
              :color="activateLabel(managerForm.ACTIVE_IND, managerForm.MANAGER_ID) == 'Inactive' ? 'red' : 'green'"
              size="24px" 
              v-model="managerForm.ACTIVE_IND"  
              :disable="!canEdit || !$p(['ADMIN'])"
              @input="updateManagerForm({field: 'ACTIVE_IND', value: managerForm.ACTIVE_IND })"/>
            </q-item-side>
          </template>
          <div>
            <user-details-manager-form :validation="validation"/>
            <!-- <user-grid-affiliate /> -->
          </div>
        </q-collapsible>
        <q-collapsible group="roles" :separator="true" v-if="$p(['ADMIN']) && (module !=='instructorApprovals')" :disable="true" class="enabled-disabled" :class="{'error': validation.administratorForm.$invalid}">
          <template slot="header">
            <q-item-main><h5><q-icon color="primary" name="fa fa-magic"></q-icon> Administrator</h5></q-item-main>
            <q-item-side right>
              <q-icon v-if="validation.administratorForm.$invalid" name="fa fa-flag" color="red" class="exclamation-circle-icon"/>
              <q-toggle 
              name="Active"
              left-label 
              :label="activateLabel(administratorForm.ACTIVE_IND, administratorForm.ADMINISTRATOR_ID)"
              :keep-color="activateLabel(administratorForm.ACTIVE_IND, administratorForm.ADMINISTRATOR_ID) == 'Inactive' ? true : false"
              :color="activateLabel(administratorForm.ACTIVE_IND, administratorForm.ADMINISTRATOR_ID) == 'Inactive' ? 'red' : 'green'"
              size="24px" 
              v-model="administratorForm.ACTIVE_IND" 
              :disable="!canEdit || !$p(['ADMIN'])"
              @change="updateAdministratorForm({field: 'ACTIVE_IND', value: administratorForm.ACTIVE_IND })"/>
            </q-item-side>
          </template>
          <div>
            <user-details-administrator-form :validation="validation"/>
            <!-- <user-grid-manager /> -->
          </div>
        </q-collapsible>
      </q-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import { required, requiredUnless, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import UserDetailsInstructorForm from './UserDetailsInstructorForm'
import UserDetailsRecruiterForm from './UserDetailsRecruiterForm'
import UserDetailsAffiliateForm from './UserDetailsAffiliateForm'
import UserDetailsManagerForm from './UserDetailsManagerForm'
import UserDetailsAdministratorForm from './UserDetailsAdministratorForm'
import UserGridManager from './UserGridManager'
import UserGridAffiliate from './UserGridAffiliate'
import UserGridRecruiter from './UserGridRecruiter'
import UserGridInstructor from './UserGridInstructor'

export default {
  name: 'UserRoles',
  components: { 
    UserDetailsAffiliateForm,
    UserDetailsInstructorForm,
    UserDetailsRecruiterForm, 
    UserDetailsManagerForm, 
    UserDetailsAdministratorForm, 
    UserGridManager,
    UserGridAffiliate,
    UserGridRecruiter,
    UserGridInstructor
  },
  props: {
    validation: Object
  },
  created () {
  },
  data () {
    return {
      module: this.$route.meta.module,
      roles: this.$store.state.users.roles
    }
  },
  computed: {
    compareFee(){
      console.log("compare fee");
      return false ;
    },
    ...mapState('users', {
      instructorForm: state => {
        return state.instructorForm
      },
      canEdit: state => state.userModal.canEdit,
      affiliateForm: state => state.affiliateForm,
      recruiterForm: state => state.recruiterForm,
      managerForm: state => state.managerForm,
      administratorForm: state => state.administratorForm
    }),
    ...mapGetters('users', [
      'userTypes'
    ])
  },
  methods: {
    abc(){
      console.log("ashish");
      return true
    },
    ...mapActions('users', [
      'submitRoleForm'
    ]),
    ...mapMutations('users', [
      'updateInstructorForm',
      'updateAffiliateForm',
      'updateRecruiterForm',
      'updateManagerForm',
      'updateAdministratorForm'
    ]),
    ...mapMutations('global', [
      'closeDetails'
    ]),
    activateLabel(condition, ID){
      if(ID && !condition) return 'Inactive'
      return condition ? "Enabled" : "Not Activated"
    }
  }
}
</script>

<style lang="stylus">
.enabled-disabled
  opacity 1 !important
  cursor pointer !important
  *
    cursor pointer !important
.q-collapsible
  &.error
    background #fff3f3
.exclamation-circle-icon
  margin-right 10px
.q-collapsible-inner
  .q-item-main
    h5
      padding 20px
  .q-collapsible-sub-item
    padding-bottom 20px
</style>
